import styled from 'styled-components';

import { KeyInfoList } from '../KeyInfoList/KeyInfoList';
import { isToday } from '../../../helpers/openingHours';
import { HTMLAttributes } from 'react';

export type OpeningHourProps = {
  day: string;
  openTime?: string;
  closeTime?: string;
  appointmentOnly?: boolean;
  appointmentOnlyText?: string;
  isOpen?: boolean;
};

export interface OpeningHoursProps {
  openingHours?: OpeningHourProps[];
  className?: string;
}

const OpeningHoursContainer = styled.section`
  background-color: ${({ theme }) => theme.colors.OFFWHITE};
  padding: ${({ theme }) => `${theme.spacing.S8} ${theme.spacing.M16}`};
`;

function OpeningHours({
  openingHours,
  className,
  ...rest
}: OpeningHoursProps & HTMLAttributes<HTMLDivElement>) {
  const mapOpeningHours =
    openingHours?.map((item) => {
      let status: 'ACTIVE' | 'CLOSED' | undefined = undefined;

      if (isToday(item.day) && item.isOpen !== undefined) {
        status = item.isOpen ? 'ACTIVE' : 'CLOSED';
      }

      return {
        displayName: item.day,
        value: getOpeningHourValue(item),
        status,
      };
    }) ?? [];

  return (
    <OpeningHoursContainer className={className} {...rest}>
      <KeyInfoList
        singleColumnOnDesktop={true}
        infoList={mapOpeningHours}
        variant="SMALL"
      />
    </OpeningHoursContainer>
  );
}

function getOpeningHourValue({
  openTime,
  closeTime,
  appointmentOnly,
  appointmentOnlyText,
}: OpeningHourProps): string {
  if (appointmentOnlyText && appointmentOnlyText !== '') {
    return appointmentOnlyText;
  } else if (appointmentOnly) {
    return 'By appointment only';
  } else if (!openTime && !closeTime) {
    return 'Closed';
  } else {
    return `${openTime} to ${closeTime}`;
  }
}

export { OpeningHours };
